/* eslint-disable arrow-body-style,import/no-cycle */
import {
    IExamDetails,
    FilteredExamStatus,
    ApproveExam,
    IApproveExam,
    ISendCodeForApproveExam,
    SendCodeForApproveExam,
    VerificationCodeSendingStatus,
} from '../../api/ApiClient';
import { createModel } from '@rematch/core';
import apiConnector from '../../api/ApiConnector';
import moment from 'moment';
import { IBodyPart, IExamIdStagePart } from 'components/models';


const initialState: IExamsState = {
    examDetails: null,
    smsCodeStatus: null,
};

export default createModel({
    state: initialState,
    reducers: {
        setExamDetails(state, examDetails: IExamDetails): IExamsState {
            return { ...state, examDetails };
        },
        clearExamDetails(state): IExamsState {
            return { ...state, examDetails: null };
        },
        setSmsCodeStatus(state: IExamsState, smsCodeStatus: VerificationCodeSendingStatus | null): IExamsState {
            return { ...state, smsCodeStatus };
        },
    },
    effects: (dispatch: any) => ({
        async fetchExamDetailsAsync(id: string) {
            const examDetails = await apiConnector.execApi(
                dispatch,
                apiClient => apiClient.getExam(id),
            );

            this.setExamDetails(examDetails);
        },

        async sendCodeForApproveExam(payload: IExamIdStagePart & IBodyPart<ISendCodeForApproveExam>) {
            const verificationCodeSendingStatus = await apiConnector.execApi(dispatch, api => api.sendCodeForApproveExam(
              payload.examId,
              payload.stage,
              new SendCodeForApproveExam(payload.body),
            ));

            this.setSmsCodeStatus(verificationCodeSendingStatus);
        },

        async approveExam(payload: IExamIdStagePart & IBodyPart<IApproveExam>) {
            const details = await apiConnector.execApi(dispatch, api => api.approveExam(
              payload.examId,
              payload.stage,
              new ApproveExam(payload.body),
            ));

            if (details) {
                this.setExamDetails(details);
            }

            return !!details;
        },
    }),
});

export interface IGetExamsList {
    qualificationIds?: string[];
    attestationSubCommissionIds?: string[];
    accreditationCenterIds?: string[];
    acIds?: string[];
    filteredExamStatus?: FilteredExamStatus | undefined;
    from?: moment.Moment;
    to?: moment.Moment;
    page?: number;
    pageSize?: number;
    sortOrder?: boolean;
    sortField?: string;
}

interface IExamsState {
    examDetails: IExamDetails | null;
    smsCodeStatus: VerificationCodeSendingStatus | null;
}
